class CoPlayerControls {
	constructor() {
		this.idPrefix = 'coplayer-';
		this.player = document.getElementById('coplayer');

		this.changeTrackTimer;

		this.widthDivisor = 450 / 16;

		this.playlistTracks = document.getElementsByClassName('playlist-track');

		this.metaValues = ['title', 'arranger', 'track_title'];
		this.scrolling = false;
		this.albumArt = document.getElementById('coplayer-album-art');
		this.currentPlaylistIndex = document.getElementById('coplayer-current-playlist-index');
		this.currentTrackAttachmentIdentifier;

		this.autoplayButton = document.getElementById('coplayer-autoplay');
		this.shuffleButton = document.getElementById('coplayer-shuffle');
		this.loopButton = document.getElementById('coplayer-loop');

		this.cancelProcessingButton = document.getElementById('coplayer-cancel-processing');

		this.monoOrStereoCheckbox = document.getElementById('coplayer-mono-stereo');
		this.flipChannelsCheckbox = document.getElementById('coplayer-flip-channels');

		this.trackIndexes = [];
		for(let i = 0; i < this.playlistTracks.length; i++) this.trackIndexes.push(i);
		this.shuffledTrackIndexes = [];
		this.shuffleTrackIndexes();

		//Window Resize
		this.adjustFontSize(this);
		window.addEventListener('resize', () => { this.adjustFontSize(this); });

		//Click Listeners
		this.listener('play-pause', 'click', this.playPause);
		this.listener('loop', 'click', this.loop);
		this.listener('loop-start', 'click', this.setLoop);
		this.listener('loop-end', 'click', this.setLoop);
		this.listener('autoplay', 'click', this.autoplay);
		this.listener('shuffle', 'click', this.shuffle);
		this.listener('options', 'click', this.options);
		this.listener('cancel-processing', 'click', this.cancelProcessing);
		this.listener('mono-stereo', 'click', this.monoStereo);
		this.listener('flip-channels', 'click', this.flipChannels);
		this.listener('color-mode', 'click', this.colorMode);
		this.listener('playlist', 'click', this.playlist);
		this.listener('forward', 'click', this.seekTrack);
		this.listener('back', 'click', this.seekTrack);
		this.listener('seek', 'input', this.seek);
		this.listener('skip-forward', 'click', this.skip);
		this.listener('skip-back', 'click', this.skip);

		//Volume
		this.listener('volume-slider', 'input', this.volume);
		this.listener('volume-soft', 'click', this.volumeButton);
		this.listener('volume-loud', 'click', this.volumeButton);

		//All Playlist Tracks
		for(let i = 0; i < this.playlistTracks.length; i++) {
			this.playlistTracks[i].addEventListener('click', () => { this.changeTrack(i, true) });
		}
		
		//All Sliders
		let sliders = ['pitch', 'speed', 'balance'];
		for(let i = 0; i < sliders.length; i++) {
			this.listener(sliders[i] + '-slider', 'input', this.slider);

			let buttons = ['decrease', 'increase'];
			for(let j = 0; j < buttons.length; j++) {
				this.listener(sliders[i] + '-adj-' + buttons[j], 'click', this.sliderButton);
			}
		}

		//Load first track
		this.changeTrack(0, false);
	}


	//====================
	// Window Resize
	//====================
	adjustFontSize(obj) {
		let newFontSize = this.player.offsetWidth / obj.widthDivisor;
		this.player.style = 'font-size: ' + newFontSize + 'px';
	}


	//====================
	// Shortcut Functions
	//====================
	listener(id, command, functionName) {
		let el = document.getElementById(this.idPrefix + id);
		el.addEventListener(command, () => { functionName(el, this); });
	}

	exchangeClass(el, from, to) {

		el.classList.remove(from);
		el.classList.add(to);
	}

	cycleButton(el, obj, statuses) {
		let index = false;
		for(let i = 0; i < statuses.length; i++) {
			if(el.classList.contains(statuses[i])) index = i;
		}

		if(index === false) index = 0;

		let statusName = (index !== statuses.length - 1) ? statuses[index + 1] : statuses[0]

		obj.exchangeClass(el, statuses[index], statusName);

		return statusName;
	}

	setButton(el, obj, statuses, statusName) {
		let index;
		for(let i = 0; i < statuses.length; i++) {
			if(el.classList.contains(statuses[i])) el.classList.remove(statuses[i]);
		}

		el.classList.add(statusName);
	}

	shuffleTrackIndexes() {
		let currentTrackIndex = parseInt(this.currentPlaylistIndex.getAttribute('value'));

		if(!currentTrackIndex) currentTrackIndex = 0;

		let trackIndexes = [];
		for(let i = 0; i < this.trackIndexes.length; i++) {
			if(i !== currentTrackIndex) trackIndexes.push(i);
		}

		let currentShuffleIndex = trackIndexes.length, randomIndex;

		while(currentShuffleIndex != 0) {
			randomIndex = Math.floor(Math.random() * currentShuffleIndex);
			currentShuffleIndex--;

			[trackIndexes[currentShuffleIndex], trackIndexes[randomIndex]] = [trackIndexes[randomIndex], trackIndexes[currentShuffleIndex]];
		}

		trackIndexes.unshift(currentTrackIndex);

		console.log(trackIndexes);

		this.shuffledTrackIndexes = trackIndexes;
	}


	//====================
	// Buttons
	//====================
	seekTrack(el, obj) {
		let direction = 'forward';
		if(el.getAttribute('id') == 'coplayer-back') direction = 'back';

		obj.advanceTrackIndex(direction, true);
	}

	advanceTrackIndex(direction, buttonPress) {
		let currentIndex = this.currentPlaylistIndex.getAttribute('value');

		let seekIndex = currentIndex;

		let min = 0;
		let max = this.playlistTracks.length - 1;

		if(direction == 'back') {
			seekIndex--;
			if(seekIndex < min) seekIndex = max;
		} else if(direction == 'forward') {
			seekIndex++;
			if(seekIndex > max) seekIndex = min;
		}

		this.changeTrack(seekIndex, buttonPress);
	}

	changeTrack(seekIndex, buttonPress) {
		let currentIndex = this.currentPlaylistIndex.getAttribute('value');

		//Only load if changing tracks or initial load
		if(seekIndex != currentIndex || !buttonPress) {
			let track = coplayer.shuffle == 'on' ? this.playlistTracks[this.shuffledTrackIndexes[seekIndex]] : this.playlistTracks[seekIndex];
			this.loadTrack(track, seekIndex, buttonPress);
		}
	}

	loadTrack(el, index, buttonPress) {
		// console.log(this.metaValues);
		// console.log(this.metaValues.length);
		for(var i = this.metaValues.length - 1; i >= 0; i--) {
			let value = el.getAttribute(this.metaValues[i]);
			if(value !== null) value = atob(value);

			document.getElementById('coplayer-meta-' + this.metaValues[i]).innerHTML = value;
			// console.log(document.getElementById('coplayer-meta-' + this.metaValues[i]));
			// console.log(atob(el.getAttribute(this.metaValues[i])));
		}

		this.scrollTitle();

		this.currentPlaylistIndex.setAttribute('value', index);

		this.currentTrackAttachmentIdentifier = el.getAttribute('identifier');

		//Get album art html
		for(let i = 0; i < el.children.length; i++) {
			if(el.children[i].classList.contains('album-art')) this.albumArt.innerHTML = el.children[i].innerHTML;
		}

		let wasPlaying = coplayer.isPlaying;

		let obj = this;

		let delay = buttonPress === true ? 500 : 0;

		clearTimeout(this.changeTrackTimer);
		this.changeTrackTimer = setTimeout(function() {
			coplayer.stop();
			coplayer.progressBar.style = 'width: 0%';
			coplayer.message.classList.remove('processing');
			coplayer.message.classList.add('loading');

			obj.player.classList.remove('playlist');
			obj.player.classList.add('processing');

			coplayer.audioElement.src = el.getAttribute('url');

			coplayer.loadAudio(el.getAttribute('url'), function(audioLoadedBuffer) {
				if(coplayer.source !== null) coplayer.source.disconnect(coplayer.splitterNode);
				coplayer.loadTrackSettings(obj.currentTrackAttachmentIdentifier, audioLoadedBuffer, wasPlaying);
			});
		}, delay);
	}

	scrollTitle() {
		let scrollTitles = document.getElementsByClassName('scroll-title');

		let obj = this;

		for(var i = scrollTitles.length - 1; i >= 0; i--) {
			// console.log(this.scrolling);

			let wrapper = scrollTitles[i];
			let span = document.getElementById(wrapper.getAttribute('scrollname'));

			let wrapperWidth = wrapper.getBoundingClientRect().width;
			let spanWidth = span.getBoundingClientRect().width;

			function scrollLeft() {
				let left = parseInt(span.style.left);

				let wrapperWidth = wrapper.getBoundingClientRect().width;
				let spanWidth = span.getBoundingClientRect().width;

				span.style.left = Math.abs(left) > spanWidth && left < 0 ? wrapperWidth + 'px' : left - 1 + 'px';
				
				let scrollTimeout = left == 1 ? 3000 : 20;

				if(spanWidth > wrapperWidth) {
					obj.scrolling = setTimeout(scrollLeft, scrollTimeout); //Continue
				} else {
					span.style = ''; //Clear style
				}
			}

			if(spanWidth > wrapperWidth) {
				span.style.left = wrapperWidth + 'px';
				span.style.right = 'initial';
				span.style.transform = 'none';
				scrollLeft();
			}
		}
	}

	scrollTitleReset() {
		let scrollTitles = document.getElementsByClassName('scroll-title');
		for(var i = scrollTitles.length - 1; i >= 0; i--) {
			let wrapper = scrollTitles[i];
			let span = document.getElementById(wrapper.getAttribute('scrollname'));
			span.style = '';
		}
	}

	playPause(el, obj) {
		coplayer.pressPlayPauseButton();
	}

	seek(el, obj) {
		coplayer.changeSeekPoint(el.value);
	}

	skip(el, obj) {
		let currentPercentage = parseFloat(coplayer.seekElement.value);
		let percentageChange = parseFloat(10 / coplayer.trackDuration);
		let newPercentage = el.getAttribute('id') == 'coplayer-skip-back' ? currentPercentage - percentageChange : currentPercentage + percentageChange;

		if(newPercentage < 0) newPercentage = 0;
		if(newPercentage > 1) newPercentage = 1;
		// if(coplayer.loopActive === true) {
		// 	if(newPercentage < coplayer.loopStart || newPercentage > coplayer.loopEnd) newPercentage = coplayer.loopStart;
		// }
		coplayer.seekElement.value = newPercentage;
		coplayer.changeSeekPoint(newPercentage);
	}

	volume(el, obj) {
		coplayer.changeVolume(el.value);
	}

	volumeButton(el, obj) {
		let slider = document.getElementById('coplayer-volume-slider');

		let direction = 'increase';
		if(el.getAttribute('id') == 'coplayer-volume-soft') direction = 'decrease';

		slider.value = obj.getSliderButtonValue(obj.getSliderValue(slider), obj.getButtonStep(slider), direction);

		coplayer.changeVolume(slider.value);
	}

	loop(el, obj) {
		let status = obj.cycleButton(el, obj, ['off', 'on']);
		obj.updateLoopStatus(status);
		coplayer.updateLoopStart(true);
	}

	updateLoopStatus(status) {
		coplayer.loopActive = status == 'off' ? false : true;

		coplayer.loopOverlay.classList.remove('off', 'on');
		coplayer.loopOverlay.classList.add(status);

		this.loopButton.classList.remove('off', 'on');
		this.loopButton.classList.add(status);

		console.log(this.currentTrackAttachmentIdentifier);

		if(coplayer.trackProcessed) coplayer.saveTrackSettings(this.currentTrackAttachmentIdentifier);
	}

	setLoop(el, obj) {
		let loopSide = 'loopStart';
		if(el.getAttribute('id') == 'coplayer-loop-end') loopSide = 'loopEnd';

		coplayer.setLoop(loopSide);
	}

	shuffle(el, obj) {
		let status = obj.cycleButton(el, obj, ['off', 'on']);
		coplayer.shuffle = status;
		coplayer.savePlayerSettings();
		if(status == 'on') obj.shuffleTrackIndexes();
	}

	autoplay(el, obj) {
		let status = obj.cycleButton(el, obj, ['off', 'on']);
		coplayer.autoplay = status;
		coplayer.savePlayerSettings();
	}

	options(el, obj) {
		obj.player.classList.toggle('advanced');
		obj.player.classList.toggle('simple');
		coplayer.playerMode = obj.player.classList.contains('advanced') ? 'advanced' : 'simple';

		//Reset scrolling titles
		clearTimeout(obj.scrolling);
		obj.scrollTitleReset();
		setTimeout(function(){
			obj.scrollTitle();
		}, 500);

		coplayer.savePlayerSettings();
	}

	cancelProcessing(el, obj) {
		//Close overlay
		coplayer.player.classList.remove('processing');

		//Stop processing
		coplayer.stretchLoopProcessing = false;

		//Reset settings
		coplayer.pitch = coplayer.previousPitch;
		coplayer.rate = coplayer.previousRate;
		coplayer.adjustedRate = coplayer.previousAdjustedRate;
		coplayer.loadTrackSettingsUI();
	}

	colorMode(el, obj) {
		obj.player.classList.toggle('light');
		obj.player.classList.toggle('dark');
		obj.cycleButton(el, obj, ['light', 'dark']);
		coplayer.colorMode = obj.player.classList.contains('light') ? 'light' : 'dark';
		coplayer.savePlayerSettings();
	}

	playlist(el, obj) {
		obj.player.classList.toggle('playlist');
	}

	slider(el, obj) {
		let type = el.getAttribute('range-type');
		let sliderValue = document.getElementById(type + '-slider-value');
		let displayValue = el.value;

		if(type === 'balance') {
			let sliderMeasurement = document.getElementById(type + '-slider-measurement');
			let measurementValue;
			if(displayValue == 0) {
				displayValue = 'Center';
				measurementValue = '';
			} else {
				let channel = el.value < 0 ? 'L' : 'R';
				displayValue = Math.abs(displayValue);
				measurementValue = '% ' + channel;
			}

			sliderMeasurement.innerHTML = measurementValue;
		}

		sliderValue.innerHTML = displayValue;

		obj[type + 'Change'](el, obj);
	}

	sliderButton(el, obj) {
		let slider = obj.getSlider(el);
		let direction = el.classList.contains('decrease') ? 'decrease' : 'increase';
		slider.value = obj.getSliderButtonValue(obj.getSliderValue(slider), obj.getButtonStep(slider), direction);
		obj.slider(slider, obj);
	}

	getSliderButtonValue(value, buttonStep, direction) {
		let adjValue = Math.round(100 * value / buttonStep) / 100;

		if(direction == 'decrease') {
			value = Math.ceil(adjValue) * buttonStep;
			return value - buttonStep;
		} else {
			value = Math.floor(adjValue) * buttonStep;
			return value + buttonStep;
		}
	}

	getSlider(el) {
		let type = el.getAttribute('range-type');
		return document.getElementById('coplayer-' + type + '-slider');
	}

	getSliderValue(slider) {
		return parseFloat(slider.value);
	}

	getButtonStep(slider) {
		return parseFloat(slider.getAttribute('button-step'));
	}


	//====================
	// Audio Processing
	//====================
	pitchChange(el, obj) {
		let slider = obj.getSlider(el);
		let value = obj.getSliderValue(slider);

		coplayer.changePitch(value);
	}

	speedChange(el, obj) {
		let slider = obj.getSlider(el);
		let value = obj.getSliderValue(slider);

		coplayer.changeRate(value);
	}

	balanceChange(el, obj) {
		let slider = obj.getSlider(el);
		let value = obj.getSliderValue(slider);
		coplayer.changePan(value / 100);

		if(coplayer.trackProcessed) coplayer.saveTrackSettings(obj.currentTrackAttachmentIdentifier);
	}

	monoStereo(el, obj) {
		obj.cycleButton(el, obj, ['stereo', 'mono']);

		let monoOrStereo = el.classList.contains('stereo') ? 'stereo' : 'mono';
		coplayer.changeNumChannels(monoOrStereo);
		coplayer.savePlayerSettings();
	}

	flipChannels(el, obj) {
		obj.cycleButton(el, obj, ['normal', 'flipped']);

		let flipChannels = el.classList.contains('flipped') ? 'flipped' : 'normal';
		coplayer.changeNumChannels(coplayer.monoOrStereo, flipChannels);

		if(coplayer.trackProcessed) coplayer.saveTrackSettings(obj.currentTrackAttachmentIdentifier);
	}

}

